module.exports = __webpack_public_path__ + "static/media/p-loader.2665a54a.gif";